module.exports = __webpack_public_path__ + "media/img/krollner-0ea2df4eaa36cd76f3ff0d5d01fecb5b.jpg";